import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

const CursorStar = () => {
  const [enabled, setEnabled] = useState(false);
  const [active, setActive] = useState(false);
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const sx = useSpring(x, { stiffness: 600, damping: 40, mass: 0.4 });
  const sy = useSpring(y, { stiffness: 600, damping: 40, mass: 0.4 });

  useEffect(() => {
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
    setEnabled(true);
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };
    const over = (e) =>
      setActive(!!e.target.closest("a, button, [data-cursor-hover]"));
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
    };
  }, [x, y]);

  if (!enabled) return null;

  return (
    <motion.div
      data-testid="cursor-star"
      aria-hidden
      style={{ translateX: sx, translateY: sy }}
      className="pointer-events-none fixed left-0 top-0 z-[9999]"
    >
      <motion.div
        style={{ translateX: "-50%", translateY: "-50%" }}
        animate={{ rotate: 360, scale: active ? 1.7 : 1 }}
        transition={{
          rotate: { repeat: Infinity, duration: 8, ease: "linear" },
          scale: { duration: 0.25, ease: [0.22, 1, 0.36, 1] },
        }}
      >
        <svg width="26" height="26" viewBox="0 0 24 24" fill="#0047FF">
          <path d="M12 0 L14.7 9.3 L24 12 L14.7 14.7 L12 24 L9.3 14.7 L0 12 L9.3 9.3 Z" />
        </svg>
      </motion.div>
    </motion.div>
  );
};

export default CursorStar;
